import React, { useState, useEffect } from "react";
import { Offcanvas, Dropdown, Button, Spinner } from "react-bootstrap";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
// import upload from "../../../assets/Fuel/upload.svg";
import { FileUploader } from "../../common/FileUploader";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import CommonDropdown from "../../common/common_dropDown";
import {
  submitReminderAPI,
  updateReminderAPI,
  getVehicleDetailsApi,
  getReminderEditApi,
} from "../services-api";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";

export const AddReminder = ({ id, show, handleClose, onSuccess }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (id != null && id !== 0) {
      getReminderEdit(id);
    }
  }, [id]);
  const resetForm = () => {
    setServiceOption(null);
    setLicensePlateOption(null);
    setVehicleName("");
    setVehicleIdentificationNumber("");
    setDescription("");
    setSelectedDate();
    setErrorMsg({
      service_id: "",
      vehicle_id: "",
      due_date: "",
      description: "",
    });
  };
  const [serviceOption, setServiceOption] = useState(null);
  const [licensePlateOption, setLicensePlateOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleIdentificationNumber, setVehicleIdentificationNumber] =
    useState("");
  const [description, setDescription] = useState("");
  const handleSelectService = (item) => {
    setServiceOption(item);
  };

  const handleSelectVehicle = (item) => {
    setLicensePlateOption(item);
    getVehicleDetails(item.value);
  };
  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);
      console.log(response.data);
      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
        setVehicleIdentificationNumber(response.data.vehicle?.vin ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const handleFileSelect = (file) => {
    console.log("Selected file:", file);
  };

  // form date
  const [selectedDate, setSelectedDate] = useState();
  const [errorMsg, setErrorMsg] = useState({
    service_id: "",
    vehicle_id: "",
    due_date: "",
    description: "",
  });

  const [isLoader, setIsLoader] = useState(false);

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        service_id: serviceOption != null ? serviceOption.value : "",
        vehicle_id: licensePlateOption != null ? licensePlateOption.value : "",
        due_date:
          selectedDate != null && selectedDate !== ""
            ? selectedDate.toLocaleDateString("en-CA")
            : "",
        description: description,
      };
      console.log(preSanitizeData);
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitReminderAPI(sanitizedData);
      } else {
        response = await updateReminderAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            service_id: "",
            vehicle_id: "",
            due_date: "",
            description: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        onSuccess(response.data);
        resetForm();
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const getReminderEdit = async (id) => {
    try {
      const response = await getReminderEditApi(id);

      if (response.data.success === true) {
        const workOrderDetail = response.data.reminder ?? {};

        setServiceOption({
          value: workOrderDetail.service_id ?? "",
          label: workOrderDetail.service ?? "",
        });
        setLicensePlateOption({
          value: workOrderDetail.vehicle_id ?? "",
          label: workOrderDetail.lic_no ?? "",
        });
        setVehicleName(workOrderDetail.name ?? "");
        setVehicleIdentificationNumber(workOrderDetail.lic_no ?? "");
        setSelectedDate(
          workOrderDetail.due_date != null && workOrderDetail.due_date !== ""
            ? new Date(workOrderDetail.due_date)
            : null
        );
        setDescription(workOrderDetail.description);
      } else {
        console.error("Error fetching reminder details:", response.data.message);
        handleClose();
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const handleCloseWithReset = () => {
    resetForm(); // Reset form state
    handleClose(); // Close the Offcanvas
  };

  return (
    <Offcanvas show={show} onHide={handleCloseWithReset} placement="end">
      <Offcanvas.Header
        closeButton={false}
        className="d-flex justify-content-between align-items-center"
      >
        <Offcanvas.Title>{id != null ? "Update service reminder" : "New service reminder"}</Offcanvas.Title>
        <button
          onClick={handleCloseWithReset}
          style={{
            backgroundColor: "transparent",
            border: "2px solid #D4DDE7",
            color: "#172B4D",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          X
        </button>
      </Offcanvas.Header>
      <hr />
      <Offcanvas.Body>
        <div className="row">
          <div className="col-6">
            <label htmlFor="fill" className="form-label fw-400 d-flex">
              Service ID<span className="error-text">*</span>
            </label>
            <CommonDropdown
              apiUrl={`${apiUrl}get_services`}
              placeholder="Select Services"
              value={serviceOption}
              onSelect={handleSelectService}
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.service_id}
            </span>
          </div>
          <div className="col-6">
            <label htmlFor="vin" className="form-label fw-400 d-flex">
              License Plate<span className="error-text">*</span>
            </label>
            <CommonDropdown
              apiUrl={`${apiUrl}get_vehicle`}
              placeholder="Select vehicle"
              value={licensePlateOption}
              onSelect={handleSelectVehicle}
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.vehicle_id}
            </span>
          </div>

          {/* Your existing form fields */}
          <div className="col-xl-6">
            <label htmlFor="vehicleName" className="form-label fw-400">
              Vehicle name
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="vehicleName"
              value={vehicleName}
              readOnly={true}
            />
          </div>
          <div className="col-xl-6">
            <label htmlFor="plate" className="form-label fw-400">
              Vehicle Identification Number (VIN)*
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="plate"
              placeholder="Auto-fill"
              value={vehicleIdentificationNumber}
              readOnly={true}
            />
          </div>
          {/* <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-3">
              Service Name
            </label>
            <Dropdown className="mb-3">
              <Dropdown.Toggle
                id="type"
                className="bg-white w-100 btn-border-grey assignment-dropdown rounded-3 px-4 d-flex justify-content-between align-items-center gap-2"
                style={{ color: "#8790A1" }}
              >
                Select <img src={chevron_down} alt="chev down" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                <Dropdown.Item>Not assigned</Dropdown.Item>
                <Dropdown.Item>Not active</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
          <div className="col-xl-6 d-flex flex-column mt-2">
            <label htmlFor="date" className="form-label fw-400 d-flex">
              Date<span className="error-text">*</span>
            </label>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="yyyy-MM-dd"
              customInput={
                <button
                  style={{ color: "#8790A1" }}
                  className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                >
                  {selectedDate ? (
                    selectedDate.toLocaleDateString()
                  ) : (
                    <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>
                  )}
                  <Calendar size={16} />
                </button>
              }
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.due_date}
            </span>
          </div>
          {/* <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400">
              Vendor
            </label>
            <Dropdown className="mb-3">
              <Dropdown.Toggle
                id="type"
                className="bg-white w-100 btn-border-grey assignment-dropdown rounded-3 px-4 d-flex justify-content-between align-items-center gap-2"
                style={{ color: "#8790A1" }}
              >
                Select <img src={chevron_down} alt="chev down" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                <Dropdown.Item>Not assigned</Dropdown.Item>
                <Dropdown.Item>Not active</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
          <div className="col-xl-6 mt-2">
            <label htmlFor="quantity" className="form-label fw-400">
              Description
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="quantity"
              placeholder="Enter here..."
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.description}
            </span>
          </div>

          {/* Upload section */}
          {/*  <FileUploader
            label="Upload fuel bill image"
            onFileSelect={handleFileSelect}
          /> */}
          {/* Footer buttons */}
          <div className="d-flex gap-3 justify-content-end mt-5">
            <Button
              className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey"
              onClick={handleCloseWithReset}
            >
              Cancel
            </Button>
            <Button
              onClick={submitForm}
              disabled={isLoader}
              className={`dark-purple-btn rounded-3 py-2 px-4 d-flex justify-content-center align-items-center ${isLoader ? "disabled-btn" : ""}`}
              style={{ minWidth: "100px" }}
            >
              {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
